module.exports = __webpack_public_path__ + "static/media/html5-with-wordmark-color.61cf40ec.svg";